import utils from '@/utils/utils'

let buttonResource = () => utils.buttonResource(
    [
        // 财务收款
        "zhgl-mmcz",      // 重置密码
    ]
)

export default buttonResource